export const blockIconsMapsFlagNew = (
	<span className='material-symbols-outlined'>flag</span>
);
